import React from 'react';
import { Link } from 'react-router-dom';
import { 
  TruckIcon, 
  GlobeAltIcon,
  EnvelopeIcon, 
  PhoneIcon, 
  MapPinIcon 
} from '@heroicons/react/24/outline';

function Footer() {
  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand Section */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-6">
              <div className="bg-gradient-to-r from-blue-600 to-orange-500 p-2 rounded-lg">
                <TruckIcon className="w-6 h-6 text-white" />
              </div>
              <div>
                <h3 className="text-xl font-bold">CargoHaul</h3>
              </div>
            </div>
            <p className="text-gray-400 mb-6 leading-relaxed text-sm">
              Your trusted logistics partner, delivering excellence worldwide with speed, reliability, and cutting-edge technology.
            </p>
            <div className="flex gap-3">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/10 hover:bg-blue-600 rounded-lg flex items-center justify-center transition-colors backdrop-blur-sm">
                <span className="text-sm font-bold">f</span>
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/10 hover:bg-blue-400 rounded-lg flex items-center justify-center transition-colors backdrop-blur-sm">
                <span className="text-sm font-bold">t</span>
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/10 hover:bg-blue-700 rounded-lg flex items-center justify-center transition-colors backdrop-blur-sm">
                <span className="text-sm font-bold">in</span>
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-bold mb-6 text-white">Services</h4>
            <ul className="space-y-3">
              <li><Link to="/services" className="text-gray-400 hover:text-orange-400 transition-colors text-sm">Express Delivery</Link></li>
              <li><Link to="/services" className="text-gray-400 hover:text-orange-400 transition-colors text-sm">Same Day Shipping</Link></li>
              <li><Link to="/services" className="text-gray-400 hover:text-orange-400 transition-colors text-sm">International Shipping</Link></li>
              <li><Link to="/services" className="text-gray-400 hover:text-orange-400 transition-colors text-sm">Freight Services</Link></li>
              <li><Link to="/services" className="text-gray-400 hover:text-orange-400 transition-colors text-sm">Warehousing</Link></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-lg font-bold mb-6 text-white">Company</h4>
            <ul className="space-y-3">
              <li><Link to="/about" className="text-gray-400 hover:text-orange-400 transition-colors text-sm">About Us</Link></li>
              <li><Link to="/contact" className="text-gray-400 hover:text-orange-400 transition-colors text-sm">Contact</Link></li>
              <li><Link to="/track" className="text-gray-400 hover:text-orange-400 transition-colors text-sm">Track Shipment</Link></li>
              <li><Link to="/services" className="text-gray-400 hover:text-orange-400 transition-colors text-sm">Services</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-bold mb-6 text-white">Contact</h4>
            <ul className="space-y-4">
              <li className="flex items-center gap-3">
                <div className="bg-blue-600/20 p-2 rounded-lg">
                  <EnvelopeIcon className="w-4 h-4 text-blue-400" />
                </div>
                <a href="mailto:support@cargohaulco.org" className="text-gray-400 hover:text-orange-400 transition-colors text-sm">
                  support@cargohaulco.org
                </a>
              </li>
              <li className="flex items-center gap-3">
                <div className="bg-blue-600/20 p-2 rounded-lg">
                  <PhoneIcon className="w-4 h-4 text-blue-400" />
                </div>
                <a href="tel:+27742586662" className="text-gray-400 hover:text-orange-400 transition-colors text-sm">
                  +27 74 258 6662
                </a>
              </li>
              <li className="flex items-center gap-3">
                <div className="bg-green-600/20 p-2 rounded-lg">
                  <PhoneIcon className="w-4 h-4 text-green-400" />
                </div>
                <a href="https://wa.me/27623676161" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-orange-400 transition-colors text-sm">
                  +27 62 367 6161 (WhatsApp)
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              &copy; {new Date().getFullYear()} CargoHaul. All rights reserved.
            </p>
            <div className="flex gap-6 text-sm">
              <Link to="/privacy" className="text-gray-400 hover:text-orange-400 transition-colors">Privacy Policy</Link>
              <Link to="/terms" className="text-gray-400 hover:text-orange-400 transition-colors">Terms of Service</Link>
              <Link to="/cookies" className="text-gray-400 hover:text-orange-400 transition-colors">Cookie Policy</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer; 